export default {
    url: '/department',
    template: '<user-group-add-department department="vm.department"/>',
    controller (ClassifierResource, CLASSIFIER_ENUM) {
        this.department = new ClassifierResource({ type: CLASSIFIER_ENUM.KEYS.DEPARTMENT });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/add/department/index.js